<template>
  <div class="text-center mt-4">
    <p>{{ $t("Claim Not Found") }}</p>
  </div>
</template>

<script>
export default {};
</script>
